import Icon from './Icon';

export { Color as IconColor, Props, BUNDLED_ICONS as IconList } from './Icon';
export default Icon;
